__turbopack_context__.v({
  "emptyState": "styles-module__l8ZqGG__emptyState",
  "itemList": "styles-module__l8ZqGG__itemList",
  "itemListMap": "styles-module__l8ZqGG__itemListMap",
});
